// extracted by mini-css-extract-plugin
export default {"notification-wrapper":"notificationPageWrapper_notification-wrapper__BDU40"};